<template>
  <div class="space-y-6">
    <div>
      <h2 class="text-xl font-semibold mb-2">Historisk data</h2>
      <p class="text-gray-600">Hantera alla dina uppladdade filer och jämför över tid</p>
    </div>

    <div v-if="uploads.length === 0" class="bg-white rounded-lg shadow p-12">
      <div class="text-center text-gray-500">
        <BaseIcon icon="file-excel" class="text-4xl mb-4 opacity-50" />
        <p>Ingen historisk data ännu</p>
        <p class="text-sm mt-2">Ladda upp din första fil för att börja spara historik</p>
      </div>
    </div>

    <div v-else class="space-y-4">
      <div v-for="upload in sortedUploads" :key="upload.id" class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center justify-between">
          <div class="flex items-start gap-4 flex-1">
            <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <BaseIcon icon="file-excel" class="text-blue-600 text-lg" />
            </div>
            <div class="flex-1 min-w-0">
              <h3 class="font-semibold truncate">{{ upload.fileName }}</h3>
              <div class="flex items-center gap-4 mt-2 text-sm text-gray-600">
                <div class="flex items-center gap-1">
                  <BaseIcon icon="calendar" class="text-xs" />
                  <span>{{ new Date(upload.uploadDate).toLocaleDateString('sv-SE', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) }}</span>
                </div>
                <span>&bull;</span>
                <span>{{ upload.rowCount }} rader</span>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button class="px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50" @click="$emit('view-upload', upload)">Visa</button>
            <button class="px-3 py-2 border border-gray-300 rounded-md text-sm text-red-600 hover:bg-red-50" @click="confirmDelete(upload)">
              <BaseIcon icon="trash" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <modal name="delete-upload-modal" :width="425" height="auto">
      <div class="p-6" v-if="uploadToDelete">
        <h3 class="text-lg font-semibold mb-2">Ta bort uppladdning?</h3>
        <p class="text-sm text-gray-600 mb-4">
          Detta kommer permanent ta bort {{ uploadToDelete.fileName }} från historiken. Denna åtgärd kan inte ångras.
        </p>
        <div class="flex justify-end gap-2">
          <button class="px-4 py-2 border border-gray-300 rounded-md text-sm" @click="$modal.hide('delete-upload-modal')">Avbryt</button>
          <button class="px-4 py-2 bg-red-600 text-white rounded-md text-sm hover:bg-red-700" @click="doDelete">Ta bort</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "PipelineHistory",
  props: {
    uploads: { type: Array, required: true },
  },
  data() {
    return {
      uploadToDelete: null,
    };
  },
  computed: {
    sortedUploads() {
      return [...this.uploads].sort((a, b) => new Date(b.uploadDate).getTime() - new Date(a.uploadDate).getTime());
    },
  },
  methods: {
    confirmDelete(upload) {
      this.uploadToDelete = upload;
      this.$modal.show("delete-upload-modal");
    },
    doDelete() {
      this.$emit("delete-upload", this.uploadToDelete.id);
      this.$modal.hide("delete-upload-modal");
      this.uploadToDelete = null;
    },
  },
};
</script>
